import { cn } from "@/lib/cn";

interface ProgressBarProps {
  value: number;
  className?: string;
  style?: React.CSSProperties;
}

function ProgressBar({ value, className, style }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn("h-1 bg-fog rounded-pill overflow-hidden", className)}
      style={style}
    >
      <div
        className="h-full bg-electric rounded-pill transition-[width] duration-med ease-default"
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}

export { ProgressBar, type ProgressBarProps };
